import { Navigate } from "react-router-dom";
import useJwtAuth from "../auth/services/jwt/useJwtAuth";

const PrivateRoute = ({ element }: { element: React.ReactElement }) => {
  const { user } = useJwtAuth();

  // Evita redirecionamento enquanto o estado do usuário não foi carregado
  if (user === undefined) {
    return null; // Pode ser um <Loading /> também
  }

  return user ? element : <Navigate to="/SignIn" replace />;
};

export default PrivateRoute;
